import { useHMSCamera } from "../hms/useHMSCamera";
import { useLivekitCamera } from "../livekit/useLivekitCamera";
import { useProviderHook } from "./useProviderHook";

export const useProviderCamera = () =>
  useProviderHook({
    hms: useHMSCamera,
    livekit: useLivekitCamera,
  })();
